// extracted by mini-css-extract-plugin
module.exports = {"rowProduct":"ProductDetail_rowProduct__3aZz0","input_number":"ProductDetail_input_number__1CLbr","input_text":"ProductDetail_input_text__7egul"};